/**
 * Base URL for REST calls from the React app.
 *
 * Sans REACT_APP_API_ORIGIN : en dev (react-scripts + setupProxy.js), chaîne vide → URLs
 * relatives `/api/...` proxifiées vers le backend (127.0.0.1:5001 par défaut).
 *
 * Forcer le mode relatif : REACT_APP_DEV_RELATIVE_API=1 (si NODE_ENV n’est pas "development").
 *
 */
export function getApiBaseUrl() {
  const fromEnv = process.env.REACT_APP_API_ORIGIN?.trim().replace(/\/$/, '');
  if (fromEnv) {
    return fromEnv;
  }

  const forceRelative = process.env.REACT_APP_DEV_RELATIVE_API === '1';
  const isDev = process.env.NODE_ENV === 'development' || forceRelative;

  if (typeof window !== 'undefined' && isDev) {
    return '';
  }

  if (typeof window !== 'undefined') {
    // Production behind a reverse proxy: use the same origin as the page
    return window.location.origin;
  }

  const port = process.env.REACT_APP_BACKEND_PORT || '5001';
  return `http://localhost:${port}`;
}
